import React from 'react';
import { Check, X } from 'lucide-react';
export function WhoIsFor() {
  return <section className="bg-gray-50 py-16 px-4" data-id="element-419">
      <div className="max-w-5xl mx-auto" data-id="element-420">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-421">
          <div className="bg-white rounded-2xl p-8 shadow-lg border-t-8 border-green-500" data-id="element-422">
            <h3 className="text-2xl font-bold text-navy mb-6 flex items-center gap-2" data-id="element-423">
              <Check className="text-green-500" size={28} data-id="element-424" />
              Who This Is For
            </h3>
            <ul className="space-y-4" data-id="element-425">
              <li className="flex items-start gap-3" data-id="element-426">
                <Check className="text-green-500 flex-shrink-0 mt-1" size={20} data-id="element-427" />
                <span className="text-gray-700" data-id="element-428">
                  Parents and grandparents who want inspiring modern role models
                  to share with their family.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-429">
                <Check className="text-green-500 flex-shrink-0 mt-1" size={20} data-id="element-430" />
                <span className="text-gray-700" data-id="element-431">
                  Anyone who wants the real story behind Charlie Kirk—without
                  the noise and clips.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-432">
                <Check className="text-green-500 flex-shrink-0 mt-1" size={20} data-id="element-433" />
                <span className="text-gray-700" data-id="element-434">
                  Busy patriots who prefer listening while commuting or working.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-435">
                <Check className="text-green-500 flex-shrink-0 mt-1" size={20} data-id="element-436" />
                <span className="text-gray-700" data-id="element-437">
                  Readers who enjoy biographies, legacy stories, and defining
                  moments.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-438">
                <Check className="text-green-500 flex-shrink-0 mt-1" size={20} data-id="element-439" />
                <span className="text-gray-700" data-id="element-440">
                  Anyone who wants a digital collector bundle they can keep and
                  revisit.
                </span>
              </li>
            </ul>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg border-t-8 border-red-500" data-id="element-441">
            <h3 className="text-2xl font-bold text-navy mb-6 flex items-center gap-2" data-id="element-442">
              <X className="text-red-500" size={28} data-id="element-443" />
              Who This Is NOT For
            </h3>
            <ul className="space-y-4" data-id="element-444">
              <li className="flex items-start gap-3" data-id="element-445">
                <X className="text-red-500 flex-shrink-0 mt-1" size={20} data-id="element-446" />
                <span className="text-gray-700" data-id="element-447">
                  Those comfortable with the current cultural direction (and not
                  interested in modern American biographies).
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-448">
                <X className="text-red-500 flex-shrink-0 mt-1" size={20} data-id="element-449" />
                <span className="text-gray-700" data-id="element-450">
                  People looking for a dry, academic biography with no heart.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-451">
                <X className="text-red-500 flex-shrink-0 mt-1" size={20} data-id="element-452" />
                <span className="text-gray-700" data-id="element-453">
                  Anyone unwilling to engage with perspectives they may disagree
                  with.
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}